const closeCustomizer = () => {
  document
    .querySelector("[data-section='product-customizer']")
    .classList.add('hidden');
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete('customizerOpen');
  searchParams.delete('cartUpdate');
  const currentUrl = window.location.href;
  const newUrl = `${currentUrl.split('?')[0]}?${searchParams.toString()}`;
  window.history.replaceState({}, '', newUrl);
  document.body.classList.remove('overflow-hidden');
};

export default closeCustomizer;
